export default __webpack_public_path__ + "static/media/card-legacy.f5d4ad6e.png";